<template>
  <div class="main">
    <Header 
      :show="true"
      title="物料盘点"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-cell :value="listQuery.date.range" is-link @click="listQuery.date.show = true">
        <template #title>
          <span style="font-size: 2vh;">时间区间</span>
        </template>
      </van-cell>
      <van-calendar 
        v-model="listQuery.date.show" 
        type="range" 
        :max-range="31" 
        :min-date="listQuery.date.min" 
        :max-date="listQuery.date.max"
        :default-date="listQuery.date.default"
        color="#ee0a24"
        :style="{ 'padding-bottom': '30px' }" 
        @confirm="onConfirmDateChoose" 
      />
      <van-cell :value="material.name" is-link @click="material.show = true">
        <template #title>
          <span style="font-size: 2vh;">物料名称</span>
        </template>
      </van-cell>
      <van-popup v-model="material.show" position="bottom">
        <van-picker
          show-toolbar
          :columns="material.columns"
          @confirm="handlePickerMaterial"
          @cancel="material.show = false"
        />
      </van-popup>
      <div style="margin: 16px;">
        <van-button round block type="info" @click="handleClickQuery">
          查询
        </van-button>
      </div>
      
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
        style="width: 100%"
      >
        <el-table-column type="expand" width="30px">
          <template slot-scope="{row}">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="序号">
                <span>{{ row.id }}</span>
              </el-form-item>
              <el-form-item label="时间">
                <span>{{ row.updatedTime }}</span>
              </el-form-item>
              <el-form-item label="类型">
                <span>{{ row.type }}</span>
              </el-form-item>
              <el-form-item label="物料">
                <span>{{ row.materialName }}</span>
              </el-form-item>
              <el-form-item v-if="row.type !== '物料库存盘点'" label="罐口">
                <span>{{ row.portName }}</span>
              </el-form-item>
              <el-form-item label="盘点前">
                <span>{{ row.inventoryBefore }}吨</span>
              </el-form-item>
              <el-form-item label="盘点后">
                <span>{{ row.inventoryAfter }}吨</span>
              </el-form-item>
              <el-form-item label="库存偏差">
                <span>{{ row.difference }}吨</span>
              </el-form-item>
              <!-- <el-form-item label="创建人">
                <span>{{ row.createdBy }}</span>
              </el-form-item>
              <el-form-item label="创建时间">
                <span>{{ row.createdTime }}</span>
              </el-form-item> -->
              <el-form-item label="操作人员">
                <span>{{ row.updatedBy }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="序号" prop="id" align="center" width="50">
          <template slot-scope="{row}">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="物料" prop="materialName" align="center" min-width="110" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{ row.materialName }}
          </template>
        </el-table-column>
        <el-table-column label="偏差" prop="difference" align="center" min-width="90" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{ row.difference }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination 
        v-show="table.total>0" 
        :total="table.total" 
        background 
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth>380?5:3"
        style="margin: .6rem 0; text-align: center;"
        @current-change="handleClickQuery"
      />
      <div style="height: 2rem; background-color: #FFFFFF;" />
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog, ImagePreview } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import { parseTime } from '@/utils'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { getConfigList as getPortList } from '@/api/port.js'
  import { getList as getMaterialList } from '@/api/material.js'
  import { getHistoryList } from '@/api/stock.js'

  export default {
    name: "ServiceHistoryMaterial",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      const EDate = parseTime(new Date(), '{y}/{m}/{d}')
      const dayTimeStamp = (new Date(EDate)).getTime()
      const beforeTimeStamp = dayTimeStamp - 7*24*3600*1000
      const SDate = parseTime(beforeTimeStamp, '{y}/{m}/{d}')
      return {
        listQuery: {
          limit: 10,
          page: 1,
          date: {
            show: false,
            min: new Date(2020, 1, 1),
            max: new Date(2030, 12, 31),
            range: SDate + ' - ' + EDate,
            start: beforeTimeStamp,
            end: dayTimeStamp,
            default: [new Date(SDate), new Date(EDate)]
          },
          material: ''
        },
        material: {
          show: false,
          name: '',
          columns: [],
          options: []
        },
        port: {
          show: false,
          name: '',
          columns: [],
          options: []
        },
        isLoading: false,
        table: {
          listLoading: false,
          fullWidth: document.documentElement.clientWidth,
          key: 0,
          total: 0,
          data: []
        },
        expandRowKeys: [],
        handleRowKey(row) {
          return row.id
        }
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleGetPortList()
      this.handleGetMaterialList()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/system/staff/create', 
          query: {} ,
        })
      },
      handleTableRowClick(row, column, event) {
        this.$refs.table.toggleRowExpansion(row)
      },
      handleRowClassName({row, rowIndex}) {
        return 'normal-row'
      },
      handleCellStyle({ row, column, rowIndex, columnIndex }) {
        return ''
      },
      onRefresh() {
        setTimeout(() => {
          this.isLoading = false
          this.listQuery.page++
          if (this.listQuery.limit * (this.listQuery.page + 1) < this.table.total) {
            this.handleClickQuery()
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, '拉取过磅记录', '没有新的数据')
          }
        }, 1000)
      },
      handleGetPortList() {
        const data = {}
        getPortList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data
            this.port.columns = []
            for (let i=0; i<items.length; i++) {
              this.port.columns.push(items[i].portName)
              this.port.options.push({
                id: items[i].id,
                name: items[i].portName,
                using: items[i].using
              })
            }
            this.handleClickQuery()
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleGetMaterialList() {
        const data = {
          limit: 10000,
          page: 1
        }
        getMaterialList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.material.columns = []
            for (let i=0; i<items.length; i++) {
              this.material.columns.push(items[i].name)
              this.material.options.push({
                id: items[i].id,
                name: items[i].name
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickQuery() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit,
          startDate: this.listQuery.date.start,
          endDate: this.listQuery.date.end,
          material: this.listQuery.material
        }
        getHistoryList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            this.table.total = data.data.total
            const items = data.data.items
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              this.table.data.push({
                id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                serial: items[i].id,
                type: items[i].type,
                materialName: items[i].materielName,
                portName: this.port.columns[items[i].port - 1],
                inventoryBefore: items[i].inventoryBefore,
                inventoryAfter: items[i].inventoryAfter,
                difference: items[i].difference,
                createdBy: items[i].createdBy,
                createdTime: parseTime(items[i].createdTime, '{y}-{m}-{d} {h}:{i}:{s}'),
                updatedBy: items[i].updatedBy,
                updatedTime: parseTime(items[i].updatedTime, '{y}-{m}-{d} {h}:{i}:{s}')
              })
            }
            console.log(this.table.total)
            console.log(this.table.data)
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      formatDate(date) {
        const year = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        return `${year}/${(month + 1) >9 ? (month + 1) : '0'+(month + 1)}/${day > 9 ? day : '0'+day}`
      },
      onConfirmDateChoose(date) {
        const [start, end] = date
        this.listQuery.date.show = false
        this.listQuery.date.range = `${this.formatDate(start)} - ${this.formatDate(end)}`
        this.listQuery.date.start = (new Date(start)).getTime()
        this.listQuery.date.end = (new Date(end)).getTime()
      },
      onSelectStatusChoose(item) {
        this.listQuery.status.show = false
        this.listQuery.status.name = item.name
        this.listQuery.status.value = item.value
      },
      handlePickerMaterial(value) {
        console.log(value)
        this.listQuery.material = value + ''
        this.material.name = value + ''
        // const options = this.material.options
        // console.log(options)
        // for (let i=0; i<options.length; i++) {
        //   if (options[i].name === value) {
        //     this.listQuery.material = options[i].id
        //     console.log(options[i].id)
        //   }
        // }
        this.material.show = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .el-form-item__label {
    width: 20%;
    text-align: right;
    // margin-right: 20px;
  }
  ::v-deep .el-table__expanded-cell[class*=cell] {
    padding: 20px 10px;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  ::v-deep .van-cell__title {
    max-width: 30%;
  }
  ::v-deep .van-cell__value {
    max-width: 70%;
  }
  ::v-deep .el-table th>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  ::v-deep .el-table td>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
